'use client'

import { Text } from '@macarongfactory/web-ui'

import {
  MODOOCAR_CODE,
  useModoocarImpression,
  useModoocarTracking,
} from '../_features/modoocar'

import type { IModoocarDetail } from '../_features/modoocar'

interface IDataDisclaimerProps {
  detail: IModoocarDetail
}

const DataDisclaimer = ({ detail }: IDataDisclaimerProps) => {
  const { itemShow } = useModoocarTracking()
  const footerRef = useModoocarImpression<HTMLElement>(() =>
    itemShow(MODOOCAR_CODE.FOOTER, 'footer', '최하단')
  )

  const isElectric = detail.fuelType === '전기'
  const basisDate = detail.dataBasisDate ?? detail.dataBasisYearMonth
  const lines = [
    `자동차 정비 예약 앱 마이클의 ${basisDate}까지 마이클 오너들의 실사용 기록을 기반으로 분석한 결과입니다.`,
    '실연비(실전비)는 마이클 오너의 실기록을 바탕으로 계산되었으며, 실제 연비(전비)는 주행거리 · 유가 · 운전 습관에 따라 달라집니다.',
    isElectric
      ? `전기요금은 기후에너지환경부의 ${basisDate} 전기 요금을 기준으로 계산되었습니다.`
      : `유가는 오피넷 ${basisDate} 유가 기준으로 계산되었습니다.`,
  ]

  return (
    <section
      ref={footerRef}
      aria-label='데이터 출처'
      className='lg:bg-background-surface-basement'
    >
      <ul className='flex flex-col bg-background-neutral-weak px-dimension-x5 pb-[120px] pt-dimension-x4 lg:pb-dimension-x10'>
        {lines.map(line => (
          <li key={line} className='flex gap-dimension-x1-5'>
            <Text
              as='span'
              aria-hidden
              variant='body-1-medium'
              color='text-foreground-neutral-alternative'
              className='shrink-0'
            >
              ·
            </Text>
            <Text
              as='span'
              variant='body-1-medium'
              color='text-foreground-neutral-alternative'
              className='flex-1 break-keep'
            >
              {line}
            </Text>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default DataDisclaimer
